export default {
  caseStudies: {
    page: {
      tagline: 'قصص نجاح من العملاء',
      headline: 'نتائج حقيقية من',
      headlineHighlight: 'فرق توصيل حقيقية',
      description:
        'اكتشف كيف تستخدم فرق التوصيل واللوجستيات — المطاعم والصيدليات والبقالة والبريد السريع والتجارة الإلكترونية و3PL — Geofleet لتبسيط المرحلة الأخيرة وخفض التكاليف وإسعاد العملاء.',
    },
    featured: { label: 'قصة نجاح مميزة' },
    filters: {
      label: 'تصفية حسب القطاع',
      allIndustries: 'جميع القطاعات',
      ariaLabel: 'تصفية دراسات الحالة حسب القطاع',
    },
    list: {
      title: 'قصص العملاء',
      defaultSubtitle: 'تحديات حقيقية وحلول عملية ونتائج قابلة للقياس عبر فرق التوصيل',
      countInIndustry_one: '{{count}} قصة في هذا القطاع',
      countInIndustry_other: '{{count}} قصص في هذا القطاع',
      story_one: '{{count}} قصة',
      story_other: '{{count}} قصص',
    },
    empty: {
      title: 'لا توجد قصص في هذا القطاع',
      hint: 'جرّب اختيار مرشح قطاع مختلف.',
    },
    card: { readFullStory: 'اقرأ القصة كاملة' },
    explore: { badge: 'كيفية الاستكشاف' },
    cta: {
      title: 'هل أنت مستعد لكتابة قصة نجاحك؟',
      subtitle: 'انضم إلى فرق التوصيل التي تحقق نتائج مماثلة مع Geofleet.',
    },
    detail: {
      schemaSection: 'دراسة حالة',
      backLink: 'جميع دراسات الحالة',
      challengeHeading: 'التحدي',
      solutionHeading: 'الحل',
      analytics: { metric: 'المؤشر', before: 'قبل', after: 'بعد' },
      timelineTitle: 'جدول التنفيذ',
      keyTakeaways: 'النقاط الرئيسية',
      relatedTitle: 'دراسات حالة ذات صلة',
      exploreSolution: {
        badge: 'استكشف الحل',
        title: 'اكتشف كيف يعمل Geofleet لـ {{industry}}',
      },
      cta: {
        title: 'احصل على نتائج مماثلة',
        subtitle: 'اكتشف كيف يمكن لـ Geofleet مساعدة فريقك. ابدأ الآن أو احجز عرضاً مخصصاً.',
      },
    },
  },
};
